/**
 * Launch configuration for Cerner.
 * @constant {LaunchConfig}
 */
export const cerner = {
    scopes: [
        // "pr_account",
        // "pr_allergyintolerance",
        // "pr_appointment",
        // "pr_binary",
        // "pr_careplan",
        // "pr_careteam",
        // "pr_chargeitem",
        // "pr_communication",
        // "pr_condition",
        // "pr_consent",
        // "pr_coverage",
        // "pr_device",
        // "pr_documentreference",
        // "pr_encounter",
        // "pr_familymemberhistory",
        // "pr_goal",
        // "pr_immunization",
        // "pr_medicationrequest",
        // "pr_nutritionorder",
        // "pr_observation",
        // "pr_patient",
        // "pr_person",
        // "pr_procedure",
        // "pr_provenance",
        // "pr_questionnaire",
        // "pr_questionnaireresponse",
        // "pr_relatedperson",
        // "pr_schedule",
        // "pr_servicerequest",
        // "pr_slot",
        // "pw_allergyintolerance",
        // "pw_appointment",
        // "pw_basic",
        // "pw_binary",
        // "pw_communication",
        // "pw_condition",
        // "pw_coverage",
        // "pw_documentreference",
        // "pw_encounter",
        // "pw_familymemberhistory",
        // "pw_immunization",
        // "pw_medicationrequest",
        // "pw_observation",
        // "pw_patient",
        // "pw_procedure",
        // "pw_provenance",
        // "pw_questionnaireresponse",
        // "pw_relatedperson",
        // "pw_slot",
        // "ur_account",
        "ur_allergyintolerance",
        // "ur_appointment",
        // "ur_binary",
        // "ur_careplan",
        // "ur_careteam",
        // "ur_chargeitem",
        // "ur_communication",
        "ur_condition",
        // "ur_consent",
        // "ur_coverage",
        // "ur_device",
        "ur_documentreference",
        "ur_encounter",
        "ur_familymemberhistory",
        // "ur_goal",
        "ur_immunization",
        "ur_location",
        "ur_medicationrequest",
        // "ur_nutritionorder",
        "ur_observation",
        "ur_organization",
        "ur_patient",
        "ur_person",
        "ur_practitioner",
        "ur_procedure",
        // "ur_provenance",
        "ur_questionnaire",
        "ur_questionnaireresponse",
        // "ur_relatedperson",
        // "ur_schedule",
        "ur_servicerequest",
        // "ur_slot",
        "uw_allergyintolerance",
        // "uw_appointment",
        // "uw_binary",
        // "uw_basic",
        "uw_communication",
        "uw_condition",
        "uw_coverage",
        "uw_documentreference",
        "uw_encounter",
        "uw_familymemberhistory",
        "uw_immunization",
        "uw_medicationrequest",
        "uw_observation",
        "uw_organization",
        "uw_patient",
        "uw_practitioner",
        "uw_procedure",
        // "uw_provenance",
        "uw_questionnaireresponse",
        "uw_relatedperson",
        // "uw_slot"
    ],
};
//# sourceMappingURL=Config.js.map